import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../lib/LanguageContext';
import { ApiHelpButton } from './ApiHelpButton';

export function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/terms');
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/privacy');
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200 pt-3 px-4 md:px-6 mt-auto">
      <div>
        <div className="flex flex-col md:flex-row items-center justify-between space-y-2 md:space-y-0 text-sm text-gray-600">
          {/* Left - Application name */}
          <div className="font-medium text-gray-700">
            Simple Stickers
          </div>
          
          {/* Center - Copyright */}
          <div className="flex items-center">
            <span>© {currentYear}</span>
          </div>
          
          {/* Right - Legal links */}
          <div className="flex items-center space-x-3">
            <ApiHelpButton className="text-gray-600 hover:text-indigo-600 transition-colors duration-200 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded">
              API/MCP Docs
            </ApiHelpButton>
            <span className="text-gray-400">•</span>
            <button
              onClick={handleTermsClick}
              className="text-gray-600 hover:text-indigo-600 transition-colors duration-200 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded"
            >
              {t('termsOfService')}
            </button>
            <span className="text-gray-400">•</span>
            <button
              onClick={handlePrivacyClick}
              className="text-gray-600 hover:text-indigo-600 transition-colors duration-200 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded"
            >
              {t('privacyPolicy')}
            </button>
          </div>
        </div>
      </div>
      
      {/* Bottom horizontal line matching header color */}
      <div className="h-[7px] bg-indigo-600  mt-3 -mx-4 md:-mx-6"></div>
    </footer>
  );
}